// Lib
import { combineReducers } from 'redux-immutable';

// Reducers
import originalLocation from './collisionOriginalLocationReducer';

export default combineReducers({
    originalLocation,
});
